import React from "react";
import { activityPriorityApi as api } from "../api/ActivityPriority.api";
import { LinesLoader } from "components/common/tools/Spinner";
import useParams from "activity/hooks/useParams";
import ActivityLoader from "activity/componenets/ActivityLoader";
import updateQueryParams from "activity/utils/updateQueryParams";

function CitiesList(props: { filterBase: "areas" | "activities" }) {
  const { filterBase } = props;
  const { data, isLoading } = api.useGetCitiesQuery({ filterBase });
  const result = data?.result ?? [];

  const cityId = useParams("cityId") || 0;

  if (isLoading) return <ActivityLoader />;

  return (
    <div className="col-3 mt-2">
      {[{ city: "All cities", id: 0 }, ...result].map((city) => {
        return (
          <h4
            style={{ cursor: "pointer" }}
            onClick={() => updateQueryParams("cityId", city.id)}
            key={city.id}
            className={`shadow rounded-2 p-2 mb-3 ${
              cityId != city.id ? "" : "bg-primary text-white"
            }`}
          >
            {city.city}
          </h4>
        );
      })}
    </div>
  );
}

export default CitiesList;
